<template>
  <SlidingSwitch v-model="isChecked" />
  <PhotoGallery v-if="!isChecked" />
  <VideoGallery v-if="isChecked" :highlightVideo="highlightVideo" />
</template>
<script>
import PhotoGallery from '../components/media/PhotoGallery.vue';
import SlidingSwitch from '../components/media/SlidingSwitch.vue';
import { useHead } from '@vueuse/head';
import VideoGallery from '../components/media/VideoGallery.vue';

export default {
  name: 'MediaView',
  components: {
    SlidingSwitch,
    PhotoGallery,
    VideoGallery,
  },
  mounted() {
    if (this.$route.query.video) {
      this.isChecked = true;
    }

    useHead({
      title: 'Media | NightKill Official',
      meta: [
        {
          name: 'description',
          content:
            'See NightKill in action — photos from past shows and videoclips.',
        },
        {
          name: 'keywords',
          content:
            'NightKill photos, live band shots, metal concert highlights, NightKill videoclips, Greece metal scene, band images, heavy metal gallery',
        },
        { property: 'og:title', content: 'Media | NightKill Official' },
        {
          property: 'og:description',
          content:
            'Explore NightKill’s videoclips and event highlights — photos from the stage and fan-fueled energy across Greece.',
        },
        {
          property: 'og:image',
          content: 'https://nightkill.gr/metadata/nightkill-logo.png',
        },
        {
          property: 'og:url',
          content: 'https://nightkill.gr/media',
        },
        { property: 'og:type', content: 'website' },
        { property: 'og:site_name', content: 'NightKill Official' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'Media | NightKill Official' },
        {
          name: 'twitter:description',
          content:
            'Videoclips and Event highlights from NightKill — photos and memories from Greece’s melodic metal scene.',
        },
        {
          name: 'twitter:image',
          content: 'https://nightkill.gr/metadata/nightkill-logo.png',
        },
      ],
      link: [{ rel: 'canonical', href: 'https://nightkill.gr/media' }],
    });
  },
  data() {
    return {
      isChecked: false,
    };
  },
  computed: {
    highlightVideo() {
      return this.$route.query.video || null;
    },
  },
  watch: {
    '$route.query.video'(newVal) {
      if (newVal) {
        this.isChecked = true;
      }
    },
  },
};
</script>

<style scoped>
/* slider button */
.media-type-switch {
  /* This is the container for the entire switch */
  position: relative; /* Essential for positioning the thumb */
  /* Add your sizing, padding, and border-radius here */
}

.slider-thumb {
  /* This is the sliding element */
  position: absolute; /* Allows it to move freely within the container */
  /* Add your sizing, background color, and border-radius here */

  /* The transition makes the movement smooth */
  transition: transform 0.3s ease-in-out;
  transform: translateX(0); /* Default position for 'photos' */
}

/* The state for the 'videos' side */
.slider-thumb.slid-right {
  transform: translateX(100%); /* Adjust this value to match your design */
}

.media-type-switch button {
  /* Style your buttons to fit your design */
  /* You can make them transparent and rely on the thumb for the visual highlight */
}
</style>
